// src/radio/radio-context.ts
import { createContext } from "react";
var RadioContext = createContext(void 0);

export {
  RadioContext
};
